/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./api/ContentStoreAPI',
	'underscore'
], (APIFactory, ContentStoreAPI, _) => {

	class ContentStore {

		constructor(ajaxService) {
			this.ajaxService = ajaxService;
			this.baseObjectUrl = 'v1/objects';
		}

		getAPI() {
			if(!this._api) {
				this._api = APIFactory.createAPI(this, [ ContentStoreAPI ]);
			}
			return this._api;
		}

		get(id = '.my_folders') {
			const path = this._preparePath(id) + '/items?fields=id,type,defaultName,modificationTime,owner{defaultName,userName,email},version';
			return this.ajaxService.get(path).then((response) => {
				return response && response.data.map((item) => {
					return {
						id: item.id,
						type: item.type,
						defaultName: item.defaultName,
						modificationTime: item.modificationTime,
						owner: {
							defaultName: _.isEmpty(item.owner) ? undefined : item.owner[0].defaultName,
							userName: _.isEmpty(item.owner) ? undefined : item.owner[0].userName,
							email: _.isEmpty(item.owner) ? undefined : item.owner[0].email
						},
						version: item.version
					};
				}) || [];
			}).catch((dfd, error) => {
				return Promise.reject({
					status: error.status
				});
			});
		}

		delete(id) {
			const path = this._preparePath(id) + '?force=true&recursive=true';
			return this.ajaxService.delete(path)
				.then()
				.catch((dfd, error) => {
					return Promise.reject({
						status: error.status
					});
				});
		}

		post(id, content) {
			const path = this._preparePath(id) + '/items';
			return this.ajaxService.post(path, {
				contentType: 'application/json',
				processData: false,
				dataType: 'text',
				data: JSON.stringify(content)
			})
				.then()
				.catch((dfd, error) => {
					return Promise.reject({
						status: error.status
					});
				});
		}

		put(id, content) {
			const path = this._preparePath(id);
			return this.ajaxService.put(path, {
				contentType: 'application/json',
				processData: false,
				dataType: 'text',
				data: JSON.stringify(content)
			})
				.then()
				.catch((dfd, error) => {
					return Promise.reject({
						status: error.status
					});
				});
		}

		_preparePath(id) {
			return this.baseObjectUrl + '/' + id;
		}

	}
	return ContentStore;
});
